class Datetime {

    getCurrentDateTime() {
        const now = new Date(),
            year = now.getFullYear(),
            month = String(now.getMonth() + 1).padStart(2, '0'),
            day = String(now.getDate()).padStart(2, '0'),
            hours = String(now.getHours()).padStart(2, '0'),
            minutes = String(now.getMinutes()).padStart(2, '0'),
            seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

}

const datetime = new Datetime();

window.Datetime = Datetime;
window.datetime = datetime;